import immerHandleActions from 'redux/utils/immerHandleActions';
import * as actions from './actions';

import { cloneDeep } from 'lodash';

const init = {
	billValue: '0',
	selectedBills: [],
};

const reducers = {
	[actions.setBillValue](_state: any, action: actions.setBillValueAction) {
		localStorage.setItem('payment_amount', action.payload.billValue);
		return { ...action.payload };
	},
	[actions.clearBillValue]() {
		localStorage.removeItem('payment_amount');
		return cloneDeep(init);
	},
	[actions.setSelectedBills](_state: any, action: any) {
		return { ..._state, selectedBills: action.payload?.selectedBills };
	},
	'persist/REHYDRATE'(_state: any, action: { payload: { bills: any } }) {
		return {
			...cloneDeep(init),
			...action?.payload?.bills,
			selectedBills: [],
		};
	},
};

export default immerHandleActions(reducers, init);
